import { api, unwrap } from "./httpClient";
import type { UserInvestment } from "../types/api";

export const getUserInvestments = async (options?: {
  limit?: number;
  offset?: number;
}): Promise<UserInvestment[]> => {
  const params = new URLSearchParams();
  if (options?.limit) {
    params.append("limit", options.limit.toString());
  }
  if (options?.offset) {
    params.append("offset", options.offset.toString());
  }

  const url = `/investments${params.toString() ? `?${params.toString()}` : ""}`;
  return unwrap<UserInvestment[]>(api({ method: "GET", url }));
};

export const getInvestmentById = async (
  investmentId: number
): Promise<UserInvestment> => {
  return unwrap<UserInvestment>(
    api({ method: "GET", url: `/investments/${investmentId}` })
  );
};

